
import { ISuKienSelectByGiaiDoanIdxRequest } from "../../../model/request/tkb/ISuKienSelectByGiaiDoanIdxRequest";
import { ISuKienUpdateRequest } from '../../../model/request/tkb/ISuKienUpdateRequest';
import { ISuKienViewModel } from '../../../model/respone/lop-tin-chi/ISuKienViewModel';
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const ePhanPhongHocActionsObj = {
  LOAD_SU_KIEN_START: {} as ISuKienSelectByGiaiDoanIdxRequest,
  LOAD_SU_KIEN_SUCCESS: {} as ISuKienViewModel[],
  LOAD_SU_KIEN_ERRR: "",

  CHANGE_FILTER: {} as ISuKienSelectByGiaiDoanIdxRequest,
  LOAD_ALL_START: {} as ISuKienSelectByGiaiDoanIdxRequest,
  LOAD_ALL_SUCCESS: {} as any,
  LOAD_ALL_ERRR: "",

  UPDATE_GV_PH_SUKIEN_START: {} as ISuKienUpdateRequest,
  UPDATE_GV_PH_SUKIEN_SUCCESS: {} as ISuKienViewModel[],
  UPDATE_GV_PH_SUKIEN_ERRR: "",

  CHANGE_SELECTED_PHONGHOC_ID:0

};
export const ePhanPhongHocActionIds = generateActionTypeIds(
  ePhanPhongHocActionsObj,
  "PHAN_PHONG_HOC"
);
export type IPhanPhongHocActionTypes = IGenericActionType<
  typeof ePhanPhongHocActionsObj,
  "PHAN_PHONG_HOC"
>;
